import BootstrapProgress from 'react-bootstrap/ProgressBar';
import cx from 'classnames';

const ProgressBar = ({ className = '', title = '', value = 40, hideLabel = false, horizontal = false }) => (
    <div className={cx('ds-progress', !horizontal && `align-items-${!title ? 'center' : 'end'}`, className)}>
        <div className={cx('d-flex-1 me-3', horizontal && 'd-flex align-items-center')}>
            {horizontal ? title && <span className="dsl-m12 progress-title me-3">{title}</span> : title && <p className="dsl-m12 progress-title mb-1">{title}</p>}
            <BootstrapProgress now={value} />
        </div>
        {!hideLabel && <div className={cx('progress-label', title && !horizontal && 'pt-3')}>{value}%</div>}
    </div>
);

export default ProgressBar;
